import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { useSilenceWithMilestone } from "@faire/retailer-visitor-shared/components/Silence/useSilenceWithMilestone";
export var SilenceChildComponent = function(param) {
    var milestone = param.milestone, maxViewCount = param.maxViewCount, children = param.children;
    var isSilenced = useSilenceWithMilestone(milestone, maxViewCount).isSilenced;
    if (isSilenced) {
        return null;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
